const cls = {
	smallHeader: 'hdr-header--small',
	smallHeaderIn: 'hdr-header--fade-in',
	searchFlyoutOpen: 'js-header-flyout-open',
	searchFlyoutTrigger: 'js-hdr-flyout-trigger',
}

const smallOffset = 150;

function isOutY(element, offset) {
	return window.pageYOffset > (element.clientHeight + offset);
}

export function init(element) {
	const searchIcon = element.querySelector(`.${cls.searchFlyoutTrigger}`);
	const toggleFlyout = _ => document.body.classList.toggle(cls.searchFlyoutOpen);
	searchIcon.addEventListener("click", toggleFlyout);

	const f = _ => {
		if(isOutY(element, 50)) {
			element.classList.add(cls.smallHeader);
		} else {
			element.classList.remove(cls.smallHeader);
			element.style.transition = "";
		}

		if(isOutY(element, smallOffset)) {
			element.classList.add(cls.smallHeaderIn);
		} else if (element.classList.contains(cls.smallHeaderIn)) {
			element.style.transition = "transform 250ms";
			element.classList.remove(cls.smallHeaderIn);
			window.setTimeout(_ => element.style.transition = "", 250);
		}
	};

	window.addEventListener('scroll', f);
}
